





















































import { Component, Vue } from 'vue-property-decorator';
import { IProxyErrorCreate, ProxyErrorTypes } from '@/interfaces';
import { dispatchCreateProxyError, dispatchGetServices, readServices } from '@/store/admin/accessors';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
  },
})
export default class CreateProxyError extends Vue {
  public valid = false;
  public statusCode: number | null = null;
  public errorCode: number = 0;
  public type: ProxyErrorTypes | null = null;
  public conn: string | null = null;
  public serviceName: string = '';
  public errorDescription: string = '';
  public userBanDuration: number = 0;

  public types = Object.values(ProxyErrorTypes);

  public servicesList = [];
  public services;

  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public async mounted() {
    await dispatchGetServices(this.$store);
    this.services = new Map<string, number>(
      readServices(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    this.servicesList = Array.from(this.services.keys());
    this.reset();
  }

  public reset() {
    this.statusCode = null;
    this.errorCode = 0;
    this.type = null;
    this.conn = null;
    this.serviceName = '';
    this.errorDescription = '';
    this.userBanDuration = 0;
    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const createdProxyError: IProxyErrorCreate = {
        status_code: this.statusCode || null,
        error_code: this.errorCode,
        service_id: this.services.get(this.serviceName),
        type: this.type || null,
        conn: this.conn || null,
        error_description: this.errorDescription,
        user_ban_duration: this.userBanDuration,
      };
      const result = await dispatchCreateProxyError(this.$store, createdProxyError);
      if (result) {
        this.$router.push('/main/admin/proxy_errors');
      }
    }
  }
}
